import { useEffect, useState } from 'react'

export interface TimerDays {
  days?: number
  hours?: number
  minutes?: number
  seconds?: number
  totalSeconds?: number
}

export const SecondsInHour = 3600
export const MinutesInHour = 60
export const SecondsInMilliseconds = 1000

export const DaysInSeconds = 86400

export const useTimer = (initialSeconds: number) => {
  const [time, setTime] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
    totalSeconds: 0,
  })

  useEffect(() => {
    const calculateTimeLeft = (totalSeconds: number) => {
      const hours = Math.floor(totalSeconds / SecondsInHour)
      const remainingSecondsAfterHours = totalSeconds % SecondsInHour
      const minutes = Math.floor(remainingSecondsAfterHours / MinutesInHour)
      const seconds = remainingSecondsAfterHours % MinutesInHour

      return {
        hours,
        minutes,
        seconds,
        totalSeconds,
      }
    }

    let totalSeconds = initialSeconds

    setTime(calculateTimeLeft(totalSeconds))

    const timer = setInterval(() => {
      if (totalSeconds === 0 || totalSeconds < 0) {
        clearInterval(timer)

        return
      }

      totalSeconds -= 1
      setTime(calculateTimeLeft(totalSeconds))
    }, SecondsInMilliseconds)

    return () => clearInterval(timer)
  }, [initialSeconds])

  return time
}
